import { render, staticRenderFns } from "./UpdateNotification.vue?vue&type=template&id=09e1c11d&scoped=true&"
import script from "./UpdateNotification.vue?vue&type=script&lang=js&"
export * from "./UpdateNotification.vue?vue&type=script&lang=js&"
import style0 from "./UpdateNotification.vue?vue&type=style&index=0&id=09e1c11d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e1c11d",
  null
  
)

export default component.exports